import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { ButtonColors } from 'src/utils/constants';
import { deleteById, Entities, fetchAll, getEntities, patch } from 'src/common/index';
import composeModalActions from 'src/utils/modal-action-wrapper';
import TableHelper from 'src/utils/table-helper';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import ErrorMessage from 'src/components/misc/error-message';
import { connect } from 'react-redux';
import { iconFormatter } from 'src/utils/formatters';
import ParentForm from 'src/components/misc/parent-form';
import { deleteTripAttribute } from 'src/actions/trip-attributes';
import TripAttributeForm from 'src/components/trips/admin/attribute/TripAttributeForm';
import { withTranslation } from 'react-i18next';
import Toggle from 'material-ui/Toggle';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';

class AdminTripAttributeAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
            renderSelection: false,
        };
    }

    componentWillMount() {
        this.props.fetchAll(Entities.TRIP_ATTRIBUTE);
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.modal.open;
    }

    componentWillReceiveProps(nextProps) {
        const { attributes } = nextProps;

        if (!this.state.startedFetching && attributes.isFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(attributes.items.length);
    }

    componentDidUpdate(prevProps) {
        if (this.tableHelper.processPaginationAfterUpdate(prevProps.attributes, this.props.attributes, this.table))
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    render() {
        const { attributes, t } = this.props;
        const finishFetching = this.state.startedFetching && !attributes.isFetching;

        const tableData = [];
        if (finishFetching && attributes.items.length > 0) {
            attributes.items.map(attribute => {
                tableData.push({
                    id: attribute.id,
                    name: attribute.name,
                    icon: attribute.icon,
                    visible: attribute.visible,
                });
            });
        }

        return (
            <div>
                <legend className="legend">
                    {t('companies.properties')}
                    {/*<button*/}
                    {/*    className="btn btn-xs btn-blue btn-flex pull-right"*/}
                    {/*    onClick={() => {*/}
                    {/*        this.table.reset();*/}
                    {/*        this.props.openModal({*/}
                    {/*            component: ParentForm,*/}
                    {/*            componentProps: {*/}
                    {/*                isCreate: true,*/}
                    {/*                mainEntityProps: {*/}
                    {/*                    entity: Entities.TRIP_ATTRIBUTE,*/}
                    {/*                    id: undefined,*/}
                    {/*                },*/}
                    {/*                childForm: {*/}
                    {/*                    component: TripAttributeForm,*/}
                    {/*                },*/}
                    {/*            },*/}
                    {/*            title: t('companies.new_property'),*/}
                    {/*        });*/}
                    {/*    }}>*/}
                    {/*    <span className="glyphicon glyphicon-plus" />*/}
                    {/*    &nbsp;{t('companies.new_property')}*/}
                    {/*</button>*/}
                </legend>

                {(() => {
                    if (attributes.error) return <ErrorMessage object={attributes} />;
                    else
                        return (
                            <BootstrapTableErrorBoundary>
                                <BootstrapTable
                                    ref={ref => (this.table = ref)}
                                    data={tableData}
                                    exportCSV={true}
                                    striped={true}
                                    hover={true}
                                    condensed={true}
                                    pagination={true}
                                    options={Object.assign(
                                        {},
                                        this.tableHelper.getOptions(finishFetching, this.state.page, tableData.length),
                                    )}
                                    selectRow={Object.assign({}, this.tableHelper.getRowProps(this.state.selected))}
                                    searchPlaceholder={t('common_phrases.search')}
                                    search={true}>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="id"
                                        hidden={true}
                                        isKey={true}
                                        export={true}>
                                        {t('common_phrases.id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn columnTitle={true} dataField="name" dataSort={true}>
                                        {t('common_phrases.name')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="icon"
                                        dataAlign="center"
                                        width="100"
                                        dataFormat={cell => iconFormatter(cell)}>
                                        {t('symbol')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="visible"
                                        width="110"
                                        dataSort={true}
                                        dataFormat={(cell, row) => <Toggle toggled={row['visible']} />}>
                                        {t('companies.visible')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="actions"
                                        width="90"
                                        dataFormat={this.tableActionsFormatter}
                                        export={false}>
                                        {t('common_phrases.actions')}
                                    </TableHeaderColumn>
                                </BootstrapTable>
                            </BootstrapTableErrorBoundary>
                        );
                })()}
            </div>
        );
    }

    onProceedDelete(attribute) {
        this.props.deleteTripAttribute(attribute.id);
    }

    openConfirmDeleteDialog(attribute) {
        const { t } = this.props;
        if (this.table) this.table.reset();
        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                event: attribute,
                onProceedDialog: this.onProceedDelete,
                bodyText: t('companies.confirm_delete_property'),
                proceedText: t('user_functionality.delete'),
                cancelText: t('common_phrases.no'),
                cancelButtonColor: ButtonColors.NOTIFY,
                proceedButtonColor: ButtonColors.DANGER,
            },
            title: attribute.name,
            noButtons: true,
        });
    }

    tableActionsFormatter(cell, attribute) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('user_functionality.edit')}
                    onClick={() => {
                        this.props.openModal({
                            component: ParentForm,
                            componentProps: {
                                isCreate: false,
                                mainEntityProps: {
                                    entity: Entities.TRIP_ATTRIBUTE,
                                    id: attribute.id,
                                },
                                childForm: {
                                    component: TripAttributeForm,
                                },
                            },
                            title: attribute.name,
                        });
                    }}>
                    <span className="glyphicon glyphicon-pencil text-info" />
                </button>
                {/*<button*/}
                {/*    type="button"*/}
                {/*    className="btn btn-xs transparent"*/}
                {/*    title={t('user_functionality.delete')}*/}
                {/*    onClick={() => this.openConfirmDeleteDialog(attribute)}>*/}
                {/*    <span className="glyphicon glyphicon-trash text-danger" />*/}
                {/*</button>*/}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        attributes: getEntities(state, Entities.TRIP_ATTRIBUTE),
    };
};

export default withTranslation()(
    connect(mapStateToProps, { fetchAll, deleteById, patch, deleteTripAttribute })(
        composeModalActions(AdminTripAttributeAdministration),
    ),
);
